import * as React from "react"
import { Skeleton } from "@mui/material"
import { AppTableSeeker } from "@components"

import { ReportsManagementNoReportDataBlock } from "./@components"
import { brandColumn, emailccColumn, frequencyColumn, infoColumn, marketColumn, conditionColumn, optionsColumn, retailerColumn, reportTypeColumn } from "./columns"
import { useReport } from "../@hooks"
import { reportIDSelected, tableData } from "../@signals"


export default function ReportsPriceChangesTable() {

    const { isLoadingTableData } = useReport()
    
    if (isLoadingTableData) return <Skeleton variant="rectangular" height={500} />
    if (!tableData.value.length) return <ReportsManagementNoReportDataBlock />

    const columns = [
        ...infoColumn(),
        ...reportTypeColumn(),
        emailccColumn(),
        ...frequencyColumn(),
        ...conditionColumn(),
        ...marketColumn(),
        ...brandColumn(),
        ...retailerColumn(),
        optionsColumn(),
    ]
   
    return <AppTableSeeker
        render={reportIDSelected.value}
        data={tableData.value}
        title="Reports Management"
        columns={columns}
        options={{
			enhancedSetRowProps: rowData => ({ sx: {
				backgroundColor: rowData?.reportID === reportIDSelected.value ? "info.lighter" : 'inherit',
				...(rowData?.alertID === reportIDSelected.value && { "&.MuiTableRow-hover:hover": {
						backgroundColor: "info.light"
					}})
			} })
		}}
    />
}